/*10-05-2023*/
////Filter information accordion start
$(document).ready(function(){
  $(document).on('click',".information-content .information-head", function () {
    $(".open").not(this).removeClass("open").next().slideUp();
    $(this).toggleClass("open").next().slideToggle();
  });
});  
////Filter information accordion end

// $( document ).ready(function() {
//   if($(".product-grid_infinite .product-block").length > 6 ){
//     $("#moreproduct-grid_pagination").show();
//   }else{
//     $("#moreproduct-grid_pagination").hide();
//   }
//   $(".main-collection_infinite .product-grid_infinite .product-block").slice(0,6).show();


  
  
//    $(document).on("click","#moreproduct-grid_pagination",function(e) {
//     e.preventDefault();
//     $(".product-grid_infinite .product-block:hidden").slice(0,6).fadeIn("slow");
//      if($(".product-grid_infinite .product-block:hidden").length == 0 || $(".product-grid_infinite .product-block").length == 0){
//        $("#moreproduct-grid_pagination").fadeOut("slow");
//       }
//   });

//     $(document).scroll(function (e) {
//      var intBottomMargin = 300;
//          // if ($(window).scrollTop() >= $('.main-collection_infinite').height() - $(window).height()) {
//          if ($(window).scrollTop() >= $('.main-collection_infinite').height() - $(window).height() + intBottomMargin) {
//             // $("#moreproduct-grid_pagination").hide();
//            console.log($(window).height());
//            $("#moreproduct-grid_pagination").click();
//         }
//     });
//   });
